import * as React from 'react';
import { ErrorNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the failure actions dispatched by `Application/AiCosts/**`. */
const AiCostsNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<ErrorNotification
				eventName="AI_COST_SUMMARY_FETCH_FAILED"
				title="Erreur"
				message="Le coût de la période n'a pas pu être chargé."
			/>
			<ErrorNotification
				eventName="AI_COST_BREAKDOWN_FETCH_FAILED"
				title="Erreur"
				message="La répartition des coûts n'a pas pu être chargée."
			/>
			<ErrorNotification
				eventName="AI_COST_CALLS_FETCH_FAILED"
				title="Erreur"
				message="Les appels d'IA n'ont pas pu être chargés."
			/>
			<ErrorNotification
				eventName="AI_COST_FILTER_OPTIONS_FETCH_FAILED"
				title="Erreur"
				message="Les listes des filtres n'ont pas pu être chargées."
			/>
			<ErrorNotification
				eventName="AI_COST_WORKBOOK_EXPORT_FAILED"
				title="Erreur"
				message="Le classeur des coûts n'a pas pu être exporté."
			/>
		</React.Fragment>
	);
};

export default AiCostsNotifications;
